(function(){
  const T = window.theme, cart = {};
  const money = c => T.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (c/100).toFixed(2)).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c/100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, (c/100).toFixed(2).replace('.',','));
  const q = (s, r=document) => r.querySelector(s), qa = (s, r=document) => [...r.querySelectorAll(s)];

  async function loadCart(){ const c = await (await fetch(T.routes.cart + '.js')).json(); apply(c); }
  function apply(c){
    Object.keys(cart).forEach(k => delete cart[k]);
    c.items.forEach(i => cart[i.variant_id] = i.quantity);
    qa('[data-product]').forEach(el => { const o = q('output', el); if (o) o.textContent = cart[el.dataset.variant] || 0; });
    const bar = q('#bar'); if (bar){ bar.hidden = false; bar.classList.toggle('show', c.item_count > 0); q('#bar-total').textContent = money(c.total_price); q('#bar-count').textContent = c.item_count; }
    if (document.body.classList.contains('template-cart')){ const s = q('.cart .total span:last-child'); if (s) s.textContent = money(c.total_price); qa('.lines li').forEach(li => { const it = c.items.find(i => i.variant_id == li.dataset.variant); li.querySelector('.line-total').textContent = it ? money(it.final_line_price) : money(0); if (!it) li.remove(); }); if (!c.item_count) location.reload(); }
  }
  async function setQty(variant, qty){
    const el = qa(`[data-product][data-variant="${variant}"]`); el.forEach(e => e.classList.add('busy'));
    let res;
    if (!cart[variant] && qty > 0) res = await fetch(T.routes.cartAdd + '.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items:[{id:+variant, quantity:qty}]})});
    else res = await fetch(T.routes.cartChange + '.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id:+variant, quantity:qty})});
    el.forEach(e => e.classList.remove('busy'));
    if (res.ok) loadCart();
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-d]'); if (!b) return;
    const p = b.closest('[data-product]'); if (!p || p.hasAttribute('data-soldout')) return;
    const v = p.dataset.variant, next = Math.max(0, (cart[v] || 0) + (+b.dataset.d));
    setQty(v, next);
  });

  // cutoff countdown in Cairo time
  function cutoff(){
    const el = q('[data-cutoff]'); if (!el) return;
    const now = new Date(new Date().toLocaleString('en-US', {timeZone:'Africa/Cairo'}));
    const mins = T.cutoffHour*60 - (now.getHours()*60 + now.getMinutes());
    if (mins > 0){ const h = Math.floor(mins/60), m = mins%60; const t = T.locale.startsWith('ar') ? `${h} س ${m} د` : `${h}h ${m}m`; el.innerHTML = T.strings.cutoffOpen.replace('{{ time }}', t); }
    else el.innerHTML = T.strings.cutoffClosed;
  }
  cutoff(); setInterval(cutoff, 30000);

  // optional WhatsApp order from cart page
  const wa = q('[data-whatsapp]');
  if (wa) wa.addEventListener('click', async () => {
    const c = await (await fetch(T.routes.cart + '.js')).json();
    const lines = [T.strings.waIntro, ...c.items.map(i => `• ${i.quantity} × ${i.product_title}`), `${T.strings.waTotal}: ${money(c.total_price)}`, '', location.origin + T.routes.root];
    window.open(`https://wa.me/${T.whatsapp}?text=${encodeURIComponent(lines.join('\n'))}`, '_blank');
  });

  // nav shadow
  const nav = q('#nav'); if (nav) addEventListener('scroll', () => nav.classList.toggle('scrolled', scrollY > 8), {passive:true});
  loadCart();
})();
